import DTextField from "components/common/DTextField";

export default function NumberFieldRenderer({
    field,
    form,
    setForm,
    errors,
    showValidation
}) {
    return (
        <DTextField
            fullWidth
            margin="normal"
            type="number"
            label={field.label}
            value={form[field.name] ?? ""}
            required={field.required}
            error={showValidation && !!errors[field.name]}
            helperText={showValidation ? (errors[field.name] ?? "") : ""}
            disabled={field.disabled}
            sx={{ marginBottom: "unset", marginTop: "unset", margin: "4px" }}
            onChange={(event) =>
                setForm((prev) => ({
                    ...prev,
                    [field.name]:
                        event.target.value === ""
                            ? ""
                            : Number(event.target.value)
                }))
            }
        />
    );
}
